export default "__VITE_ASSET__BSJZ8BMb__"